module.exports = __webpack_public_path__ + "img/logo_white@2x.d333ed2e.png";